function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "70",
  height: "56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "10.25",
  y: "6.24",
  width: "49.5",
  height: "43.519",
  rx: "1.5",
  stroke: "#59C3C3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "15.254",
  y: "24.315",
  width: "39",
  height: "21",
  rx: "1",
  fill: "#7E86A0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.252 32.618c-1.143 0-2.072.93-2.072 2.072 0 1.143.93 2.072 2.072 2.072 1.143 0 2.072-.93 2.072-2.072 0-1.143-.93-2.072-2.072-2.072zm0 3.443c-.756 0-1.37-.615-1.37-1.37 0-.757.614-1.372 1.37-1.372a1.372 1.372 0 010 2.741z",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.452 34.34h-.954a6.262 6.262 0 00-5.895-5.896v-.954H34.9v.954a6.262 6.262 0 00-5.895 5.895h-.954v.702h.954a6.262 6.262 0 005.895 5.895v.954h.702v-.954a6.262 6.262 0 005.895-5.895h.954v-.702zm-6.85 5.895v-.918h-.7v.918a5.562 5.562 0 01-5.195-5.194h.918v-.702h-.918a5.562 5.562 0 015.194-5.194v.919h.702v-.919a5.562 5.562 0 015.194 5.194h-.918v.702h.918a5.561 5.561 0 01-5.194 5.194z",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.701 27.29h1.102v.967a6.463 6.463 0 015.881 5.882h.968v1.102h-.968a6.463 6.463 0 01-5.881 5.882v.967H34.7v-.967a6.463 6.463 0 01-5.882-5.882h-.967v-1.102h.967a6.463 6.463 0 015.882-5.881v-.968zm.4.4v.943l-.189.01a6.062 6.062 0 00-5.706 5.708l-.011.188h-.943v.302h.943l.01.189a6.062 6.062 0 005.707 5.707l.19.01v.943h.3v-.943l.19-.01a6.062 6.062 0 005.706-5.707l.01-.19h.944v-.3h-.944l-.01-.19a6.062 6.062 0 00-5.707-5.707l-.188-.01v-.943H35.1zm.302 1.242l.212.014a5.762 5.762 0 015.381 5.38l.014.213h-.931v.302h.93l-.013.212a5.762 5.762 0 01-5.38 5.381l-.213.014v-.931H35.1v.93l-.212-.013a5.762 5.762 0 01-5.381-5.38l-.014-.213h.931v-.302h-.93l.013-.212a5.762 5.762 0 015.38-5.381l.213-.014v.932h.302v-.932zm-5.478 5.207h.9v1.102h-.9a5.363 5.363 0 004.776 4.776v-.9h1.102v.9a5.363 5.363 0 004.776-4.776h-.9v-1.102h.9a5.363 5.363 0 00-4.776-4.777v.902H34.7v-.901a5.363 5.363 0 00-4.776 4.776zm3.055.551a2.275 2.275 0 012.272-2.272 2.275 2.275 0 012.272 2.272 2.274 2.274 0 01-2.272 2.272 2.275 2.275 0 01-2.272-2.272zm2.272-1.872c-1.032 0-1.872.84-1.872 1.872s.84 1.872 1.872 1.872 1.872-.84 1.872-1.872-.84-1.872-1.872-1.872zm0 .701c-.646 0-1.17.526-1.17 1.171a1.172 1.172 0 002.34 0c0-.645-.524-1.17-1.17-1.17zm-1.57 1.171c0-.866.704-1.57 1.57-1.57.866 0 1.57.704 1.57 1.57a1.572 1.572 0 01-3.14 0z",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "15.754",
  y: "11.24",
  width: "38",
  height: "8.76",
  rx: "1.5",
  stroke: "#59C3C3"
})));